import _ from "lodash";

/*
this function is used to return the percentage vertical scroll bar position for specific scrolable div
*/
function calculateScrollPercentage(div_id) {
    const scrollableDiv = document.getElementById(div_id);
    
    const totalHeight = scrollableDiv.scrollHeight; // Total scrollable height
    const currentScroll = scrollableDiv.scrollTop;  // Current scrolled position
    const containerHeight = scrollableDiv.clientHeight; // Visible height of the container

    const scrollableContentHeight = totalHeight - containerHeight;
    const scrollPercentage = (currentScroll / scrollableContentHeight) * 100;

    return scrollPercentage.toFixed(2); // Returns a fixed decimal string
}

/*
this function is used to throttle the call of another function
*/
function throttle(func, limit) {
    let inThrottle;
    return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    }
}

function slugify(text) {
  return _.chain(text)
    .deburr()                           // Remove diacritical marks
    .toLower()                          // Convert to lowercase
    .replace(/[^\w\s-]/g, '')           // Remove all non-word chars (except spaces and hyphens)
    .replace(/[\s_-]+/g, '-')           // Replace spaces, underscores, and multiple hyphens with a single hyphen
    .trim('-')                          // Trim hyphens from start and end
    .value();                           // Extract the resulting value
}

function isMobileView(breakpoint) {
    breakpoint = breakpoint || 640; // default breakpoint
    return $(window).width() <= breakpoint;
}

export {
    calculateScrollPercentage,
    throttle,
    slugify,
    isMobileView
}

